import { Button, Dropdown, Input, Menu, Space } from "antd";
import { FilterIcon, SearchIcon, SortIcon } from "assets/svgs";
import { useAppDispatch, useAppSelector, useDebounce } from "hooks";
import { useToggle } from "hooks/useToggle";
import { FC, useCallback, useEffect, useState } from "react";
import {
  getSearchAndOrderBy,
  setOrderBy,
  setSearch,
} from "store/ducks/filterHackathon/slice";
import FilterDrawer from "./FilterDrawer";
import styles from "./Search.module.css";

const Search: FC = () => {
  const dispatch = useAppDispatch();
  const [open, toggleOpen] = useToggle(false);
  const { order_by, search } = useAppSelector(getSearchAndOrderBy);
  const [searchTerm, setSearchTerm] = useState(search);
  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  useEffect(() => {
    setSearchTerm((old) => (searchTerm !== search ? search : old));
  }, [search]);

  useEffect(() => {
    dispatch(setSearch(debouncedSearchTerm));
  }, [debouncedSearchTerm]);

  const handleSearchChange = useCallback((e: any) => {
    setSearchTerm(e.target.value);
  }, []);

  const handleFilterSelect = useCallback(({ key }: any) => {
    dispatch(setOrderBy(key));
  }, []);

  return (
    <div className={styles.root}>
      <div className={styles.input}>
        <SearchIcon />
        <input
          onChange={handleSearchChange}
          placeholder="Search with hackathon name, skills, tech, etc."
        />
      </div>

      <Space size={24}>
        <Button onClick={toggleOpen} className={styles.btn}>
          <FilterIcon />
        </Button>
        <Dropdown
          trigger={["click"]}
          overlay={
            <Menu
              selectedKeys={[order_by]}
              onClick={handleFilterSelect}
              className={styles.menuActive}
            >
              <Menu.Item key="relevant">Most Relevant</Menu.Item>
              <Menu.Item key="submission">Submission Date</Menu.Item>
              <Menu.Item key="added">Recently Added</Menu.Item>
              <Menu.Item key="prize">Prize Amount</Menu.Item>
            </Menu>
          }
        >
          <Button className={styles.btn}>
            <SortIcon />
          </Button>
        </Dropdown>
      </Space>

      <FilterDrawer open={open} onClose={toggleOpen} />
    </div>
  );
};

export default Search;
